import { ServiceData } from '@/types';

import articles from './COOKING_ARTICLES_FI.json';
import recipes from './COOKING_RECIPES_FI.json';
import videos from './COOKING_VIDEOS_FI.json';

export const COOKING_DATA_FI: ServiceData = {
  articles,
  recipes,
  videos,
};
